import { render, staticRenderFns } from "./PackingOrders.vue?vue&type=template&id=27d6e7db"
import script from "./PackingOrders.vue?vue&type=script&lang=js"
export * from "./PackingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports